(() => {
  'use strict';

  if (window.__mcDesktopGalleryResetLoaded) return;
  window.__mcDesktopGalleryResetLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 768px)');
  let wasMobile = mobileQuery.matches;
  let reloadPending = false;

  const handleViewportChange = (event) => {
    const isMobile = event.matches;

    if (wasMobile && !isMobile && !reloadPending) {
      reloadPending = true;
      window.location.reload();
      return;
    }

    wasMobile = isMobile;
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleViewportChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleViewportChange);
  }
})();
